import { render } from "./headerBar.vue?vue&type=template&id=78ffaf9b"
import script from "./headerBar.vue?vue&type=script&lang=js"
export * from "./headerBar.vue?vue&type=script&lang=js"

import "./headerBar.vue?vue&type=style&index=0&id=78ffaf9b&lang=css"
script.render = render

export default script